import React from 'react';
import '../styles/theme.css';
import '../styles/Landing.css';
import MontreauxSiteHeader from '../components/MontreauxSiteHeader';
import Footer from '../components/Footer';
import LandingApplyFoot from '../components/LandingApplyFoot';
import LandingHero from '../components/LandingHero';
import LandingWhatMontreauxIs from '../components/LandingWhatMontreauxIs';
import LandingLoanOfferingPanels from '../components/LandingLoanOfferingPanels';
/* IMPORTS */

function LandingPage() {
  return (
    <div className="la-root">
      <div className="la-layout-1">
        <div id="montreauxsiteheader" className="la-slot-montreauxsiteheader">
          <MontreauxSiteHeader activePage={"Landing"} />
        </div>
        <div id="landinghero" className="la-slot-landinghero">
          <LandingHero />
        </div>
        <div id="landingwhatmontreauxis" className="la-slot-landingwhatmontreauxis">
          <LandingWhatMontreauxIs />
        </div>
        <div id="landingloanofferingpanels" className="la-slot-landingloanofferingpanels">
          <LandingLoanOfferingPanels />
        </div>
        <div id="landingapplyfoot" className="la-slot-landingapplyfoot">
          <LandingApplyFoot />
        </div>
        <div id="footer" className="la-slot-footer">
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default LandingPage;